import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { IWebEditSimulationAction } from '../../spacesPlatform/models/actionNames';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { editSimulation } from '../actions/EditSimulationReduxAction';

export const EditSimulationEntityAction: IEntityAction<IContentInfo<'simulation'>, IWebEditSimulationAction> = {
  name: EntityActionNames.EditSimulation,
  translateName: Messages.editSimulation,
  isVisible: () => {return true; },
  isClickable: (availableActions: IWebEditSimulationAction) => !!availableActions && availableActions.webEditSimulation,
  createReduxAction: (targetItems: IContentInfo[]) => editSimulation(targetItems[0])
};
